import type { ReceivedInvoiceReceiptType } from '@/context/services/invoice/type';
import { useMemo } from 'react';

export type ReceiptType = 'paper' | 'e_doc';

export const RECEIPT_TYPES = {
  PAPER: 'paper' as const,
  E_DOC: 'e_doc' as const,
};

export const useReceiptTypeChecks = (
  receiptType?: ReceivedInvoiceReceiptType
) => {
  return useMemo(() => {
    const isPaper = receiptType === RECEIPT_TYPES.PAPER;
    const isEDoc = receiptType === RECEIPT_TYPES.E_DOC;

    return {
      isPaperReceipt: isPaper,
      isEDocReceipt: isEDoc,
      receiptType,
    };
  }, [receiptType]);
};
